"use client"

import { ArrowBigRightDash } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ArrowBigRightDashIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ArrowBigRightDashIcon = component(Icon)({ as: ArrowBigRightDash })
